// third-party
import { combineReducers } from 'redux';

// project import
import appreducer from './appreducer';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ appreducer });

export default reducers;
